import nanoajax from 'nanoajax';

class VimeoHelper {
  constructor(accessToken = null) {
    this.accessToken = accessToken;
  }

  setAccessToken(token) {
    this.accessToken = token;
  }

  getVideoMetadata(videoId) {
    return new Promise((resolve, reject) => {
      if (!this.accessToken) {
        reject(new Error('Access token is not set'));
        return;
      }

      nanoajax.ajax({
        url: `https://api.vimeo.com/videos/${videoId}`,
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${this.accessToken}`
        }
      }, (code, responseText) => {
        if (code === 200) {
          const videoMetadata = JSON.parse(responseText);
          resolve(videoMetadata);
        } else {
          console.error('Error fetching video metadata:', code, responseText);
          reject(new Error('Failed to fetch video metadata'));
        }
      });
    });
  }
}

export default new VimeoHelper(__GLOBAL__.vimeoAccessToken);
